import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-chart-bars',
  templateUrl: './chart-bars.component.html',
  styleUrls: ['./chart-bars.component.scss'],
})
export class ChartBarsComponent {

  @Input() @HostBinding('style.width') width = 'unset';
  @Input() @HostBinding('style.height') height = 'unset';
  @Input() values: number[];

  getBarPath(x: number, percent: number) {
    return `M${x},30 v${Math.max(0, Math.min(100, Number(percent) ?? 0))}`;
  }

  getMonth(index: number) {
    return new Date(2021, index, 1, 12, 0, 0);
  }
}
